<template>
	<div class="knd-help" >
		
		<div class="knd-help-bg">
			<svg width="1512" height="982" viewBox="0 0 1512 982" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g filter="url(#filter0_f_107_432)">
				<circle cx="756" cy="491" r="363" fill="#2A3700"/>
				</g>
				<defs>
				<filter id="filter0_f_107_432" x="-7" y="-272" width="1526" height="1526" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
				<feFlood flood-opacity="0" result="BackgroundImageFix"/>
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
				<feGaussianBlur stdDeviation="200" result="effect1_foregroundBlur_107_432"/>
				</filter>
				</defs>
			</svg>
		</div>


		<div class="knd-instanties knd-paragraaf">
			<div class="knd-flex-container">
				<div class="knd-instantie item" 
					v-for="(instantie, index) in data.instanties" 
					:key="'instantie-' + index"
					:class="{'active' : slide == instantie.slide, 'next-active' : slide == instantie.slide -1, 'in-active': instantie.slide < slide }"
				>
					<div @click="openModal(instantie)">{{ instantie.naam }}</div>
				</div>
			</div>
		</div>
			<div class="knd-help-container">


				<div class="knd-help-intro" :class="{'active' : slide == 0}">
					<div class="knd-title knd-paragraaf">
						<h2 class="knd-h2" v-html="data.tekst"></h2>
						<p>{{ data.ondertitel }}</p>
					</div>
					
				</div>	
				
				<div class="knd-btn-container">
					<div class="btn-help-label">
						<span v-if="slide == 0">Zoek hulp door hier te drukken</span>
						<span v-if="slide == 1">Klik op een organisatie voor meer informatie</span>
					</div>

					<div class="knd-btn" @click="onClick" :style="{'--btnScale': slide === end ? 1 : (slide * 0.2) + 1}">
						<svg  v-if="!isEnd" width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
							<circle cx="50.5" cy="50.5" r="33.5" fill="#00DEB2" stroke="#00DEB2" stroke-width="2"/>
							<circle class="ripple-circle" cx="50.5" cy="50.5" r="33.5" fill="#00DEB2" stroke="#00DEB2" stroke-width="2"/>
							<circle class="ripple-circle" cx="50.5" cy="50.5" r="33.5" fill="#00DEB2" stroke="#00DEB2" stroke-width="2"/>
							<circle class="ripple-circle" cx="50.5" cy="50.5" r="33.5" fill="#00DEB2" stroke="#00DEB2" stroke-width="2"/>
							<circle class="ripple-circle" cx="50.5" cy="50.5" r="33.5" fill="#00DEB2" stroke="#00DEB2" stroke-width="2"/>

							
							<path class="" d="M28.888 49.232H36.052V36.2H38.752V65H36.052V51.932H28.888V65H26.188V36.2H28.888V49.232ZM41.0942 36.2H49.7343V38.9H43.7943V49.232H49.7343V51.932H43.7943V62.3H49.7343V65H41.0942V36.2ZM52.063 36.2H54.763V62.3H60.703V65H52.063V36.2ZM66.7825 36.2C69.0625 36.2 70.7665 36.488 71.8945 37.064C73.0465 37.64 73.8025 38.516 74.1625 39.692C74.5465 40.844 74.7385 42.476 74.7385 44.588V46.064C74.7385 48.152 74.5465 49.784 74.1625 50.96C73.8025 52.112 73.0465 52.988 71.8945 53.588C70.7665 54.164 69.0625 54.452 66.7825 54.452H65.4505V65H62.7505V36.2H66.7825ZM65.4505 38.9V51.752H66.7825C68.3905 51.752 69.5545 51.584 70.2745 51.248C70.9945 50.912 71.4625 50.372 71.6785 49.628C71.9185 48.86 72.0385 47.672 72.0385 46.064V44.588C72.0385 42.98 71.9185 41.804 71.6785 41.06C71.4625 40.292 70.9945 39.74 70.2745 39.404C69.5545 39.068 68.3905 38.9 66.7825 38.9H65.4505Z" fill="#4E243F"/>
							<!-- <path  d="M25.6498 6.85972C20.2845 2.67025 12.6366 2.93064 7.84621 7.72101C2.65042 12.9168 2.78382 21.4743 8.14417 26.8346C13.5045 32.195 22.062 32.3284 27.2578 27.1326C27.869 26.5213 28.8758 26.537 29.5064 27.1676C30.1371 27.7983 30.1528 28.805 29.5415 29.4163C23.1231 35.8346 12.5522 35.6698 5.93057 29.0482C-0.691042 22.4266 -0.855831 11.8556 5.5625 5.4373C11.5065 -0.506662 21.0119 -0.80464 27.6438 4.44305L27.5328 3.92752C27.3469 3.06379 27.892 2.23462 28.7503 2.07552C29.6087 1.91643 30.4552 2.48765 30.6412 3.35138L31.8493 8.96307C32.0832 10.0497 31.1717 11.0042 30.0772 10.8188L24.2185 9.82646C23.3485 9.6791 22.7408 8.85776 22.8611 7.99195C22.9814 7.12614 23.7841 6.54372 24.6541 6.69108L25.6498 6.85972Z" fill="#00DEB2"/> -->
						</svg>



						<svg v-if="isEnd" width="85" height="85" viewBox="0 0 85 85" fill="none" xmlns="http://www.w3.org/2000/svg">
							<circle cx="42.5" cy="42.5" r="41.5" stroke="#00DEB2" stroke-width="2"/>
							<path d="M49.6498 32.8597C44.2845 28.6703 36.6366 28.9306 31.8462 33.721C26.6504 38.9168 26.7838 47.4743 32.1442 52.8346C37.5045 58.195 46.062 58.3284 51.2578 53.1326C51.869 52.5213 52.8758 52.537 53.5064 53.1676C54.1371 53.7983 54.1528 54.805 53.5415 55.4163C47.1231 61.8346 36.5522 61.6698 29.9306 55.0482C23.309 48.4266 23.1442 37.8556 29.5625 31.4373C35.5065 25.4933 45.0119 25.1954 51.6438 30.4431L51.5328 29.9275C51.3469 29.0638 51.892 28.2346 52.7503 28.0755C53.6087 27.9164 54.4552 28.4876 54.6412 29.3514L55.8493 34.9631C56.0832 36.0497 55.1717 37.0042 54.0772 36.8188L48.2185 35.8265C47.3485 35.6791 46.7408 34.8578 46.8611 33.9919C46.9814 33.1261 47.7841 32.5437 48.6541 32.6911L49.6498 32.8597Z" fill="#00DEB2"/>
						</svg>

					</div>
				</div>
			</div>

			<Modal :hideFn='hideModal' :show="showModal">
				<h3 class="knd-modal-title">{{instantie.naam}}</h3>
				<div v-html="instantie.omschrijving"></div>
			</Modal>

		</div>
</template>

<script>

import Modal from './modal.vue';

export default {
	name: 'Instanties',
    props: ['data'],
	components:{Modal},
	data() {
		return {
			slide: 0,
			end: 3,
			isEnd: false,
			instantie: false,
			showModal: false
		}
	},
	mounted: function() {
	},
	methods: {
		onClick() {
			let next = this.slide + 1;
			if(next > this.end) {
				next = 0;
			} 
			
			this.isEnd = next === this.end;
			this.slide = next;
		},

		hideModal() {
			this.showModal = false;

			document.body.style.overflow = 'inherit';
		},

		openModal(instantie) {
			this.instantie = instantie;
			this.showModal = true;

			document.body.style.overflow = 'hidden';
		}
	}
}
</script>


<style lang="scss">

.knd-help-container {
	display: flex;
	align-items: center;
	// justify-content: center;
	flex-direction:column;
	height: 100%;
	justify-content: center;
	// position: relative;
	color: rgb(244, 255, 231);
	.knd-title {
		color: rgb(244, 255, 231);
	}
}
.knd-btn-container {
	z-index: 100;
	.btn-help-label {
		font-weight: 200;
		height: 30px;
		margin-bottom: 1em;	
	}
}


.knd-help {
  text-align: center;
	position: relative;
  background: var(--instanties-background);
  color: var(--instanties-color);
	min-height: 100vh;

	@include md { 
		max-height: 960px;
		min-height: auto;
	}

	.knd-help-intro {
		position: relative;
		opacity: 0;
		pointer-events: none;

		transition: opacity .6s ease-in-out;

    align-items: center;
    justify-content: center;
		// flex: 1;
    display: flex;
    flex-direction: column;

		&.active {
			pointer-events: all;
			opacity: 1;
		}

			&.next-active {
			opacity: 0.1;
			}
	}

	.knd-help-bg {
		position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    pointer-events: none;

		svg {
			width: 100%;
		}
	}

	.knd-btn {
		cursor: pointer;
		position: relative;
		z-index: 0;
		opacity: .8;
    display: inline-block;
		transition: opacity .2s ease-in, transform .5s ease-out;
		transform: scale(var(--btnScale));
		margin-bottom: 2em;

		&:hover {
			opacity: 1;
		}

		svg {
			user-select: none;
		}
	}
}

.knd-pulse {
	animation: pulse 2s infinite;
}

@keyframes pulse {
	0% {
		transform: scale(0.95);
	}

	70% {
		transform: scale(1);
	}

	100% {
		transform: scale(0.95);
	}
}

.knd-instanties {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	// z-index: 100;
}

.knd-flex-container {
	display: flex;
	text-align: center;
	justify-content: center;
	flex-flow: wrap;
  align-items: center;
  height: 70%;

	@include sm { 
		height: 50%;
	}

	.item {
		margin: 0 0.5em;
		@include sm { 
			font-size:30px;
			// margin: 0 4em;
			margin: 0 1em;
		}


	}
}

.grid-container {
  padding: 20px;
  display: grid;
  grid-gap: 20px;
  grid-auto-rows: 1fr;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-flow:dense;
	height: 80%;

	// display: flex;
	// flex-wrap: wrap;
	// align-items: center;
	// justify-content: center;

	@include sm { 
		grid-template-columns: repeat(3, 1fr);
	}

	@include md { 
		grid-template-columns: repeat(4, 1fr);

	}
}

.item {
	font-family: $font-header;
	user-select: none;
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
	color: #D0FFEB;
	opacity: .05;
	// text-transform: lowercase;
	transition-delay: 1s;
	transition: opacity .8s ease-in, filter .8s ease-in;
	pointer-events: none;
	// margin-right: 20px;
	font-weight: 200;
	letter-spacing: 1px;

	&.in-active {
		filter: blur(2.5px);
		opacity: .5;
	}

	&.active {
		opacity: 1;
		pointer-events: all;
		// text-decoration: underline;
		cursor: pointer;
	}
}

.ripple-circle {
		opacity: 0.5;
		transform-origin: center center;
		animation: pulseripple 3s ease-out infinite;
		&:nth-of-type(1) {
					animation-delay: -0.5s;
		}
		
		&:nth-of-type(2) {
					animation-delay: -1s;
		}
		
		&:nth-of-type(3) {
					animation-delay: -1.5s;
		}
}


@keyframes pulseripple {
      100% {
        transform: scale(1.4);
        opacity: 0;
      }
}

</style>